import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Modal, ModalBody, ModalHeader,
} from 'reactstrap';
import {
  modalHight,
}
  from '../../../utils';
import MessageList from './MessageList';

function MessageContainer(props) {
  const { offerId, openOfferDetail } = props;
  const {
    isOpen, onClose,
  } = props;
  const [modal, setModal] = useState(isOpen);
  const toggle = () => {
    setModal(!modal);
    onClose();
    document.body.classList.remove('messageModalOpen');
  };


  return (
    <Modal isOpen={modal} className="modal-message" style={modalHight}>
      <ModalBody>
        <ModalHeader toggle={toggle} className="modal-blank-header" />
        <MessageList offerId={offerId} openOfferDetail={openOfferDetail} toggleChatModal={toggle} />
      </ModalBody>
    </Modal>
  );
}
MessageContainer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  offerId: PropTypes.string,
  openOfferDetail: PropTypes.func,
};

MessageContainer.defaultProps = {
  offerId: null,
  openOfferDetail: null,
};
export default React.memo(MessageContainer);
